export const Keys = { LAST_PAGE: 'lastPage' };
